<script>
import { defineComponent } from 'vue'
import TwCard from '@/components/generic/tw-card.vue'

export default defineComponent({
  name: 'WebConnexIntegrationSuccessPage',
  components: { TwCard }
})
</script>

<template>
  <div>
    <tw-card class="bg-green-200 text-green-900 text-center text-3xl w-1/2 mx-auto mt-20">
      Success! You can now close this window and return to RedPodium.
    </tw-card>
  </div>
</template>

<style scoped>

</style>
